<template>
  <div>
    <h1 class="mb-8 text-3xl font-bold">
      Dashboard
    </h1>
    <p class="mb-8 leading-normal">
      Selamat datang di aplikasi SAPBKPP
    </p>

    <div v-if="mahasiswa" class="overflow-x-auto bg-white rounded-md shadow">
      <biodata-verification-status
        v-if="currentVerificationStatus.id !== 3"
        :status-list="verificationStatus"
        :status-current="currentVerificationStatus"
        :mahasiswa="mahasiswa" />

      <student-report-status
        v-if="currentVerificationStatus.id === 3 && !isEosPaymentSuccess"
        :status-list="verificationStatus"
        :status-current="currentVerificationStatus"
        :mahasiswa="mahasiswa"
        :latest-student-report="latestStudentReport"
        :pivot-student-education-id="pivotStudentEducationId" />

      <eos-verification-info
        v-if="isEosPaymentSuccess"
        :status-list="verificationStatus"
        :status-current="currentVerificationStatus"
        :mahasiswa="mahasiswa"
        :is-eos-payment-success="isEosPaymentSuccess" />
    </div>
    <not-verified-info v-else />
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import NotVerifiedInfo from './NotVerifiedInfo.vue'
import BiodataVerificationStatus from './BiodataVerificationStatus.vue'
import StudentReportStatus from './StudentReportStatus.vue'
import EosVerificationInfo from './EosVerificationInfo.vue'

export default {
    name: 'DashboardMahasiswa',
    layout: Layout,
    metaInfo: { title: 'Dashboard' },
    components: {
        NotVerifiedInfo,
        BiodataVerificationStatus,
        StudentReportStatus,
        EosVerificationInfo,
    },
    props: {
        verificationStatus: Array,
        mahasiswa: Object,
        isEosPaymentSuccess: Boolean,
        pivotStudentEducationId: Number,
        latestStudentReport: Object,
    },
    computed: {
        currentVerificationStatus () {
            return this.$page.props.auth.user.mahasiwa_verification_status
        },
    },
}
</script>
